import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChevronUp = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size, transform: 'rotate(180deg)' }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.64645 6.14645C3.84171 5.95118 4.15829 5.95118 4.35355 6.14645L8 9.79289L11.6464 6.14645C11.8417 5.95118 12.1583 5.95118 12.3536 6.14645C12.5488 6.34171 12.5488 6.65829 12.3536 6.85355L8.35355 10.8536C8.15829 11.0488 7.84171 11.0488 7.64645 10.8536L3.64645 6.85355C3.45118 6.65829 3.45118 6.34171 3.64645 6.14645Z"
      />
    </svg>
  )
})

export default ChevronUp
